import InlineCallOut from './inline-callout';

export default InlineCallOut;
export { default as InlineCalloutAssembly } from './assembly';
